import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://strapi.efficienttour.com/api", // adjust if Strapi runs on a different URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
